import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="M7 6.079C7 4.379 8.343 3 10 3s3 1.378 3 3.079V8.92c0 1.7-1.343 3.079-3 3.079S7 10.62 7 8.92V6.079Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" /> <path d="M4.792 10.625S5 14.375 10 14.375s5.208-3.75 5.208-3.75M10 14.792v2.25" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);